var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 22,
    viewBox: "0 0 22 22",
    width: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h28v28h-28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14 3.5c-5.80040323 0-10.5 4.69959677-10.5 10.5 0 5.8004032 4.69959677 10.5 10.5 10.5 5.8004032 0 10.5-4.6995968 10.5-10.5 0-5.80040323-4.6995968-10.5-10.5-10.5zm2.4175403 14.8227823-3.7342742-2.7139113c-.13125-.0973791-.2074596-.2497984-.2074596-.4106855v-7.12560485c0-.27943549.228629-.50806452.5080645-.50806452h2.032258c.2794355 0 .5080645.22862903.5080645.50806452v5.83004035l2.6885081 1.9560484c.228629.1651209.2752016.4826612.1100807.7112903l-1.1939517 1.6427419c-.1651209.2243952-.4826612.2752016-.7112903.1100807z",
    fill: "#eceff4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTime);
export default __webpack_public_path__ + "static/media/icon-time.3a714a18.svg";
export { ForwardRef as ReactComponent };